<template>
  <tk-search-condition-box
    :dep-place="condition.departurePlaceName"
    :dep-date="departureDate"
    :dest-places="destinationNames"
    :duration="condition.durationFrom"
    :people-num="condition.numberOfPassengers"
    :url="url"
    :disabled="disabled"
    :icon-color="iconColor"
    :button-text="buttonText"
    :button-theme="buttonTheme"
    :border="border"
    @execute="$emit('execute')"
  />
</template>

<script>
import { uniq } from 'lodash'
import { TkSearchConditionBox } from '@ota-frontend/ui'
import { SearchCondition } from '@/models'

export default {
  name: 'SearchConditionBox',

  components: { TkSearchConditionBox },

  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
    url: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: undefined,  // packages/ui の TkIcon に連携されるカラープリセット
    },
    buttonText: {
      type: String,
      default: undefined,  // デフォルトで PC: "条件変更"、SP: "変更"
    },
    buttonTheme: {
      type: String,
      default: 'default',  // default: 四角ボタン、round-corners: 丸角ボタン
    },
    border: {
      type: Boolean,
      default: false,  // false(デフォルト): 枠線なし, true: 枠線あり
    },
  },

  computed: {
    departureDate() {
      const month = this.condition.departureMonth ? `${String(this.condition.departureMonth).padStart(2, '0')}月` : ''
      const day = this.condition.departureDay ? `${String(this.condition.departureDay).padStart(2, '0')}日` : ''
      return `${month}${day}`
    },
    destinationNames() {
      return uniq(this.condition.destinations.map(d => d.name).filter(Boolean))
    },
  },
}
</script>
